import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConnectionStatusService {
  private isServerReachable$ = new BehaviorSubject<boolean>(true);

  constructor() {}

  /**
   * Call this when a network error occurs (server unreachable)
   */
  markServerUnreachable(): void {
    this.isServerReachable$.next(false);
  }

  /**
   * Call this when a successful HTTP response is received
   */
  markServerReachable(): void {
    this.isServerReachable$.next(true);
  }

  /**
   * Get current connection status as observable
   */
  get connectionStatus$() {
    return this.isServerReachable$.asObservable();
  }

  /**
   * Get current connection status value
   */
  get isServerReachable(): boolean {
    return this.isServerReachable$.value;
  }
}
